import React from 'react';
import { Header } from 'semantic-ui-react';

const Message = props => (
  <div>
    <Header style={{ fontSize: '1em' }} as="span" color="blue">
      {props.message.username}:{' '}
    </Header>
    <Header
      style={{ fontWeight: 'normal', fontSize: '1em' }}
      as="span"
      color="black"
    >
      {props.message.text}
    </Header>
  </div>
);

export default Message;



// WEBPACK FOOTER //
// ./src/containers/Chat/components/ChatComponent/components/Messages/components/Message/index.jsx